export const LABELING_ROUTE_PATH = '/labeling';
export const CAM_ROUTE_PATH = '/cam';
